<template>
  <div class="container">
    <div class="flex">
      <p class="section">{{ $store.state.section }}</p>
      <div class="wrap">
        <div class="fromto">
          <p class="distance" v-html="from"></p>
          <p class="distance" v-html="to"></p>
        </div>
        <div class="total">
          <CounterComponent class="denominator" :count="denominator"/>
          <div class="numerator">
            <p>{{ numerator }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from "lodash";
import CounterComponent from "@/components/Counter.vue";

const distance = [
  "0.0",
  "21.3",
  "44.4",
  "65.8",
  "86.7",
  "107.5",
  "128.3",
  "149.6",
  "171.0",
  "194.1",
  "217.1"
];
export default {
  name: "RaceCounterComponent",
  components: {
    CounterComponent
  },
  computed: {
    from() {
      return this.formatData(this.$store.state.section - 1);
    },
    to() {
      return this.formatData(this.$store.state.section);
    },
    denominator() {
      // console.log(this.$store.state.total)
      return this.$store.state.total;
    },
    numerator() {
      return this.$store.state.section * 23;
    }
  },
  methods: {
    formatData(index) {
      let split = distance[index].split(".");
      return `${split[0]}<span>.${split[1]} km</span>`;
    }
  }
};
</script>

<style scoped lang="scss">
$space: 0.78em;
.container {
  background-color: $text-color;
  color: $bg-color;
  padding: vw(15);
}
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
  line-height: 1;
}
.wrap {
  display: flex;
}
.section {
  font-size: vw(110);
  width: 1.2em;
  height: $space;
}
.distance {
  font-size: vw(36);
  height: $space;
  /deep/ span {
    font-size: vw(24);
  }
}
.fromto {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url("../assets/img/arrow_down.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: vw(24) auto;
  height: vw(86);
  padding-right: vw(20);
  margin-right: vw(20);
  &::after {
    content: "";
    width: vw(4);
    height: 100%;
    background-color: $bg-color;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.total {
  position: relative;
  display: flex;
  margin-left: vw(10);
}
.denominator {
  font-size: vw(48);
  text-align: right;
}
.numerator {
  display: flex;
  justify-content: flex-end;
  background-image: url("../assets/img/slash.svg");
  background-repeat: no-repeat;
  background-position: left center;
  background-size: vw(81) vw(86);
  width: vw(100);
  height: vw(86);
  margin-left: -1.8em;
  > p {
    font-size: vw(38);
    height: $space;
    margin-top: auto;
  }
}
</style>
